import React, {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {Trans} from 'react-i18next';
import {signOut} from '../../auth/reducers';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

function Logout({signOut}) {
  const [show, setShow] = useState(false);

  return (
    <div className="kt-header__topbar-item">
      <div className="kt-header__topbar-wrapper">
        <span className="kt-header__topbar-icon" onClick={() => setShow(true)}>
          <i className="flaticon-logout" />
        </span>
      </div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        onShow={() => console.log(document.body)}
      >
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="c.l.header.logout.title">Logout</Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Trans i18nKey="c.l.header.logout.desc">
            Do you really want to logout?
          </Trans>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            <Trans i18nKey="common.button.no">No</Trans>
          </Button>
          <Button
            variant="primary"
            onClick={() => signOut().catch(setShow(false))}
          >
            <Trans i18nKey="common.button.yes">Yes</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default connect(
  null,
  dispatch => bindActionCreators({signOut}, dispatch)
)(Logout);
